import { formatMonthDateYear } from '@dataGrid/gridUtilities';

const holidayRangeValueFormatter = (params) => {
  const holidays = params.data.holidays;
  if (!holidays) {
    return [];
  }
  return holidays.map((holiday) => getHolidayDateValue({ data: holiday }));
};

const holidayRangeValueGetter = (params) => {
  return params.data.holidays.map((holiday) => holidayValueGetter({ data: holiday }));
};

const holidayValueGetter = (params) => {
  return formatMonthDateYear({ value: params.data.holidayDate });
};

const getCustomerHolidayValidationsProps = (holidays, selectedOption) => {
  const isHolidayAlreadyAdded = holidays?.some(
    (holiday) => holiday.holidayId === selectedOption?.value
  );
  const isSameDayAlreadyAdded = holidays?.some(
    (holiday) => holiday.holidayDate === selectedOption?.holidayDate
  );
  return { isHolidayAlreadyAdded, isSameDayAlreadyAdded };
};

const getHolidayDateValue = (params) => {
  if (params.data.isCustomerSpecificHoliday) {
    if (params.data.holidayDate && params.data.holidayEndDate) {
      return `${formatMonthDateYear({ value: params.data.holidayDate })} - ${formatMonthDateYear({
        value: params.data.holidayEndDate
      })}`;
    } else {
      return '';
    }
  } else {
    return formatMonthDateYear({ ...params, value: params.data.holidayDate });
  }
};

const getCustomerSpecificHolidayValidations = (holidays, dateRange) => {
  let errorMessage = null;
  const isSameDayAlreadyAdded =
    dateRange?.holidayStartDate === dateRange?.holidayEndDate &&
    holidays?.some((holiday) => holiday.holidayDate === dateRange?.holidayStartDate);
  if (isSameDayAlreadyAdded) {
    errorMessage = 'Another holiday is already added on the same day!';
  }
  return errorMessage;
};

export {
  holidayRangeValueGetter,
  holidayRangeValueFormatter,
  getCustomerHolidayValidationsProps,
  getHolidayDateValue,
  holidayValueGetter,
  getCustomerSpecificHolidayValidations
};
